import { render } from "./VehicleGroup.vue?vue&type=template&id=136227dd&scoped=true"
import script from "./VehicleGroup.vue?vue&type=script&lang=js"
export * from "./VehicleGroup.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-136227dd"

export default script